import * as types from './types';
import Vue from 'vue';
import api from '@/api/signworkflows';
import store from '@/store';
import SignBookTransformer from '@/transformers/SignBookTransformer';
import downloadjs from 'downloadjs';

export default {
  createSignworkflow({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.createSignworkflow(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.create.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: `${Vue.$i18n.t('store.signworkflows.create.error')} <br> ${error.data.message}`,
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  async getSignBookById({ commit, dispatch }, signBookId) {
    store.dispatch('application/startLoading');
    try {
      const { status, data } = await api.getSignBookById({ signBookId });
      if (status === 'success') {
        commit(types.SET_SIGNBOOK, SignBookTransformer.fetch(data));
        return Promise.resolve(data);
      }
      return Promise.reject(data);
    } catch (error) {
      dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },
  getFolderFromSafe({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.getFolderFromSafe(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.getFolder.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getDocumentFromSafe({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.getDocumentFromSafe(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.getDocument.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  archiveSignworkflow({ commit }, params) {
    // loader
    store.dispatch('application/startLoading');
    return api.archiveSignworkflow(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.archive.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.archive.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  deleteSignworkflow({ commit }, params) {
    // loader
    store.dispatch('application/startLoading');
    return api.deleteSignworkflow(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.delete.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.delete.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  sendSignature({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.sendSignature(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.sign.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        if (error.data.message === 'signature password is wrong') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.sign.wrongPwd'),
            time: 3,
            type: 'error',
          });
        } else {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.sign.error'),
            time: 3,
            type: 'error',
          });
        }
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  sendUSBSignature({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.sendUSBSignature(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.signUsb.success'),
            time: 5,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.signUsb.error'),
          time: 5,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  refuseSignature({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.refuseSignature(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.refuse.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.refuse.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  sendReminder({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.sendReminder(params)
      .then((response) => {
        if (response.status === 'success') {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.signworkflows.reminder.success'),
            time: 3,
            type: 'success',
          });
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.reminder.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  updateStepDeadline({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.updateStepDeadline(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  updateStepSignatory({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.updateStepSignatory(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  updateParaphAlert({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.updateParaphAlert(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  deleteStep({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.deleteStep(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getDocBinaryContent({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.getDocBinaryContent(params)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getDocContent({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.getDocContent(params)
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  downloadDoc({ commit }, [id, filename]) {
    store.dispatch('application/startLoading');
    return api.downloadDoc({ id })
      .then((response) => {
        downloadjs(response, `${filename}.pdf`);
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.downloadDoc.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getArchive({ commit }, [signBookId, filename]) {
    store.dispatch('application/startLoading');
    return api.getArchive({ signBookId })
      .then((response) => {
        downloadjs(response, `${filename}.zip`);
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.getArchive.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getSignworkflows({ commit, state }, params) {
    // loader
    store.dispatch('application/startLoading');
    // save search params
    commit(types.SET_SIGNWORKFLOWS_SEARCH_PARAMS, params);
    // parse such params for request
    const storeParams = JSON.parse(JSON.stringify(params));
    storeParams.offset = params.offset.toString();
    storeParams.limit = params.limit.toString();
    // remove dates params depending on status
    if (storeParams.params && storeParams.params.length > 0 && (storeParams.params[0].paramValue === 'waiting-for-others' ||
        storeParams.params[0].paramValue === 'waiting-for-action' ||
        storeParams.params[0].paramValue === 'expire-soon' ||
        storeParams.params[0].paramValue === 'expired')) {
      storeParams.params.splice(storeParams.params.findIndex(x => x.paramName === 'creationDateStart'), 1);
      storeParams.params.splice(storeParams.params.findIndex(x => x.paramName === 'creationDateEnd'), 1);
    }
    // call api function
    return api.getSignworkflows(storeParams)
      .then((response) => {
        if (response.status === 'success') {
          commit(types.SET_SIGNWORKFLOWS, response.data);
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        commit(types.RESET_SIGNWORKFLOWS);
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflows.get.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },
  getByThirdPartyId() {
    // loader
    store.dispatch('application/startLoading');
    // call api function
    return api.getSignworkflowForThirdParty()
      .then((response) => {
        if (response.status === 'success') {
          return Promise.resolve(response.data);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.signworkflow.get.error'),
          time: 3,
          type: 'error',
        });
        return Promise.reject(error);
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },

  async searchFieldOnPDF({ dispatch }, value) {
    dispatch('application/startLoading', null, { root: true });
    try {
      const { status, data } = await api.searchFieldOnPDF(value);
      if (status === 'success') {
        return Promise.resolve(data);
      }
      return Promise.reject(data);
    } catch (error) {
      dispatch('application/displaySnackbar', {
        text: Vue.$i18n.t('store.signworkflows.getCoord.error'),
        time: 3,
        type: 'error',
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },

  resetSearchParams({ commit }) {
    commit(types.SET_SIGNWORKFLOWS_SEARCH_PARAMS, {
      orders: [
        {
          fieldName: 'creationDate',
          orderBy: 'DESC',
        },
      ],
      params: [
        { paramName: 'status', paramValue: 'inbox' },
        { paramName: 'creationDateStart', paramValue: '' },
        { paramName: 'creationDateEnd', paramValue: '' },
      ],
      offset: 0,
      limit: 20,
    });
  },
  clear({ commit }) {
    store.dispatch('signworkflows/resetSearchParams');
    commit(types.RESET_SIGNWORKFLOWS);
  },
  async transformToTemplate({ commit }, params) {
    store.dispatch('application/startLoading');
    try {
      let response = await api.transformToTemplate(params);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.transformToTemplate.error'));
      }
      return response.data;
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/parapheurs/actions.js